export const DAO_CODE = 'TRAINING_PRODUCT_ORIGIN' + '_DAO';
